import { IPatient } from '@alberta/konexi-shared';
import { PatientDB } from 'src/app/common/repository/databases';
import { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
import { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';
import { QueryService } from 'src/app/shared/services/query/query.service';

import { Logger } from '@common/logging/logger';
import { PrescriptionChainHandler } from './prescription-chain-handler';

export class PatientHandler extends PrescriptionChainHandler {
  constructor(
    private _queryService: QueryService,
    private _logger: Logger
  ) {
    super();
  }
  async handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
    // TODO: birthday is a Date in konexi.shared (which is wrong - should be string)
    const patient = await this._queryService.get<IPatient>(request.patientId, PatientDB);
    if (patient) {
      prescriptionRequestDto.patient = {
        customerNumber: patient.customerId,
        birthday: patient.birthday as any,
        name: `${patient.firstName} ${patient.lastName}`,
        additionalName: '',
        address: patient.address,
        postalCode: patient.postalCode,
        city: patient.city,
      };
      prescriptionRequestDto.regionId = patient.regionId;
    } else {
      this._logger.captureErrorWithExtras(
        `{19160 critical | Patient not found for Prescription Request - patientID provided:  ${request.patientId}}`,
        new Error(
          `{19160 critical | Patient not found for Prescription Request - patientID provided:  ${request.patientId}}`
        ),
        new Map(),
        'error'
      );
    }
    return this.next.handleRequest(prescriptionRequestDto, request);
  }
}
